import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchRegenerateBilling } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const   RegenerateBillingChartSlice: Slice<any, {}, "RegenerateBillingChartSlice"> = createSlice({
    name: "RegenerateBillingChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchRegenerateBilling.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchRegenerateBilling.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchRegenerateBilling.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default RegenerateBillingChartSlice
